import { z } from 'zod';
import type { AISchemaField, UISchemaField } from '../types/index';

export const ctaBannerAISchema: AISchemaField[] = [
  { name: 'eyebrow', type: 'string', required: false, max: 30 },
  { name: 'headline', type: 'string', required: true, max: 80 },
  { name: 'subheadline', type: 'string', required: false, max: 200 },
  { name: 'primaryCta', type: 'string', required: true, max: 24 },
  { name: 'primaryCtaHref', type: 'url', required: false },
  { name: 'secondaryCta', type: 'string', required: false, max: 24 },
  { name: 'secondaryCtaHref', type: 'url', required: false },
  { name: 'image', type: 'image_url', required: false },
  { name: 'emailPlaceholder', type: 'string', required: false, max: 60, hint: 'メール入力欄のプレースホルダー (split_form variant のみ、省略時は you@studio.com)' },
];

export const ctaBannerUISchema: UISchemaField[] = [
  { name: 'eyebrow', type: 'text', label: 'Eyebrow', max: 30 },
  { name: 'headline', type: 'textarea', label: 'Headline', required: true, max: 80 },
  { name: 'subheadline', type: 'textarea', label: 'Subheadline', max: 200 },
  { name: 'primaryCta', type: 'text', label: 'Primary CTA', required: true, max: 24 },
  { name: 'primaryCtaHref', type: 'cta_url', label: 'プライマリ CTA リンク' },
  { name: 'secondaryCta', type: 'text', label: 'Secondary CTA', max: 24 },
  { name: 'secondaryCtaHref', type: 'cta_url', label: 'セカンダリ CTA リンク' },
  { name: 'image', type: 'image', label: 'Image' },
  { name: 'emailPlaceholder', type: 'text', label: 'メール欄プレースホルダー (split_form のみ)', max: 60, placeholder: 'you@studio.com' },
];

export const ctaBannerZodSchema = z.object({
  eyebrow: z.string().max(30).optional().nullable(),
  headline: z.string().min(1).max(80),
  subheadline: z.string().max(200).optional().nullable(),
  primaryCta: z.string().min(1).max(24),
  primaryCtaHref: z.string().optional().nullable(),
  secondaryCta: z.string().max(24).optional().nullable(),
  secondaryCtaHref: z.string().optional().nullable(),
  image: z.string().optional().nullable(),
  emailPlaceholder: z.string().max(60).optional().nullable(),
});

export type CtaBannerContent = z.infer<typeof ctaBannerZodSchema>;

export const ctaBannerSample: CtaBannerContent = {
  eyebrow: 'Ready when you are',
  headline: 'Configure yours today.',
  subheadline: 'Free shipping. 14-day return policy. Trade in your old gear for credit.',
  primaryCta: 'Configure',
  primaryCtaHref: '#',
  secondaryCta: 'Talk to sales',
  secondaryCtaHref: '#',
  image: null,
  emailPlaceholder: null,
};
